import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-slider',
  templateUrl: './skeleton-slider.component.html',
  styleUrls: ['./skeleton-slider.component.scss']
})
export class SkeletonSliderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
